import React, {
  useEffect, useState, useRef,
} from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getTotem, setCidade, setAuthToken } from '../../api/apiFactory';
import {
  fetchCarregarSolicitante,
  fetchLimparCookie, fetchNomeCidade, fetchSolicitanteOcorrencias, fetchSolicitanteSic,
  fetchSolicitanteZeladoria,
} from '../../api/endpoints';
import {
  definirCidade, desfazerCidade, fetchConfiguracoesCidade, selectCidade,
} from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import {
  resetarModais, selectModal, abrirModalAjuda, fecharModalAnonimo,
} from '../../app/slices/modalSlice';
import { desfazerSecretaria } from '../../app/slices/secretariasSlice';
import { ReactComponent as ListaSvg } from '../../assets/icons/lista.svg';
import AppHeader from '../../components/AppHeader/AppHeader';
import Botao from '../../components/Botao/Botao';
import { AbaContainer } from '../../components/Botao/BotaoEstilo';
import Carregar from '../../components/Carregar/Carregar';
import HeaderLista from '../../components/HeaderLista/HeaderLista';
import ListaOcorrencias from '../../components/ListaOcorrencias/ListaOcorrencias';
import ListaSic from '../../components/ListaSic/ListaSic';
import ListaZeladorias from '../../components/ListaZeladorias/ListaZeladorias';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalImpressao from '../../components/ModalImpressao/ModalImpressao';
import ModalImpressaoSic from '../../components/ModalImpressao/ModalImpressaoSic';
import ModalImpressaoZeladoria from '../../components/ModalImpressao/ModalImpressaoZeladoria';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import ModalInformacaoAcompanhamento from '../../components/ModalInformacaoAcompanhamento/ModalInformacaoAcompanhamento';
import VisualizadorArquivos from '../../components/VisualizadorArquivos/VisualizadorArquivos';
import {
  Alerta,
  AppBody, AppFragment, BreadCumbs, CampoForm, CampoFormTotem, Centro, Container, ContainerTotem, Divisor, Interno, Linha, Titulo,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';

const defaultValues = {
  BuscaOcorrencia: '',
  BuscaSic: '',
  BuscaZeladoria: '',
};

const IniciarAcompanhamentoTotem = ({
  ouvidoria, sic, zeladoria,
}) => {
  const [listaOcorrencias, setListaOcorrencias] = useState(null);
  const [listaSic, setListaSic] = useState(null);
  const [listaZeladorias, setListaZeladorias] = useState(null);

  const [sicAtivo, setSicAtivo] = useState(false);
  const [ouvidoriaAtivo, setOuvidoriaAtivo] = useState(true);
  const [zeladoriaAtivo, setZeladoriaAtivo] = useState(true);

  const [values, setValues] = useState(defaultValues);
  const [refresh, setRefresh] = useState(false);
  const [carregando, setCarregando] = useState(false);

  const [resultadoPesquisaOuvidoriaAnonimo, setResultadoPesquisaOuvidoriaAnonimo] = useState(null);
  const [resultadoPesquisaSicAnonimo, setResultadoPesquisaSicAnonimo] = useState(null);
  const [resultadoPesquisaZeladoriaAnonimo, setResultadoPesquisaZeladoriaAnonimo] = useState(null);

  const [nomeUsuario, setNomeUsuario] = useState('');
  const dispatch = useDispatch();

  const carregandoCallback = (callback) => {
    setCarregando(callback);
  };

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const dadosLogin = useSelector(selectLogin);
  const dadosModal = useSelector(selectModal);
  const dadosCidade = useSelector(selectCidade);

  const history = useHistory();

  window.onload = () => {
    dispatch(resetarModais());
  };

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  const formataNome = (nomes) => {
    const words = nomes.length > 0 && nomes.toLowerCase().split(' ');

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    return words && words.join(' ');
  };

  useEffect(() => {
    if (cookieId) {
      const escolherCidadeCookie = async (Id, Campo) => {
        setCidade({ Id, Campo });
        dispatch(definirCidade({
          idCidade: Id,
          nomeCidade: Campo,
        }));
        await fetchLimparCookie();
        await dispatch(fetchConfiguracoesCidade());
      };
      dispatch(desfazerConexao());
      fetchNomeCidade(cookieId).then((nomeCidade) => escolherCidadeCookie(cookieId, nomeCidade));
    }

    if ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'S'
      && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoSic === 'S' || dadosCidade.configuracoes.OcultarAnonimoSic === 'S'))
      && (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'N'
        && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoZeladoria === 'N' || dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'N'))
      && (dadosCidade && dadosCidade.configuracoes && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoOuvidoria === 'N' || dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N'))) {
      setOuvidoriaAtivo(false);
      setSicAtivo(true);
      setZeladoriaAtivo(false);
    }

    if ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'N'
      && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoSic === 'N' || dadosCidade.configuracoes.OcultarAnonimoSic === 'N'))
      && (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'S'
        && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoZeladoria === 'S' || dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'S'))
      && (dadosCidade && dadosCidade.configuracoes && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoOuvidoria === 'N' || dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N'))) {
      setOuvidoriaAtivo(false);
      setSicAtivo(false);
      setZeladoriaAtivo(true);
    }

    if (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') {
      Promise.all([
        fetchSolicitanteOcorrencias(),
        fetchSolicitanteSic(),
        fetchSolicitanteZeladoria(),
      ]).then(([dadosOcorrencias, dadosSic, dadosZeladorias]) => {
        setListaOcorrencias(dadosOcorrencias);
        setListaSic(dadosSic);
        setListaZeladorias(dadosZeladorias);
        setRefresh(false);
      });
    }
  }, [dadosLogin, refresh, cookieId, carregando]);

  useEffect(() => {
    if (dadosCidade.configuracoes.AcompanhamentoAnonimo === 'N') {
      dispatch(fecharModalAnonimo());
    }
    fetchCarregarSolicitante().then((dados) => setNomeUsuario(dados.Solicitante));
  }, []);

  const handleVoltar = () => {
    if (ouvidoria) {
      history.push('/totem/ouvidoria');
    }
    if (sic) {
      history.push('/totem/sic');
    }
    if (zeladoria) {
      history.push('/totem/zeladoria');
    }
  };

  if (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') {
    if (!listaOcorrencias || !listaSic || !listaZeladorias) {
      return (
        <Carregar />
      );
    }
    if (listaOcorrencias.Error || listaSic.Error || listaZeladorias.Error) {
      history.push('/');
      dispatch(desfazerConexao());
      dispatch(desfazerCidade());
      dispatch(desfazerSecretaria());
      return (
        <Carregar />
      );
    }

    // logado
    if (ouvidoria) {
      if (listaOcorrencias.Message) {
        return (
          <AppFragment
            onKeyDown={(e) => {
              if (e.key === 'Escape') {
                dispatch(resetarModais());
              }
            }}
            tabIndex="0"
          >
            {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
            {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
            {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
            {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
            {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
            <Botao
              voltar
              label="Voltar"
              style={{
                marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
              }}
              onClick={() => handleVoltar()}
            />
            {(dadosLogin && dadosLogin.data) && (
              <Botao
                sair
                label="Sair"
                style={{ marginRight: espacamento.pequeno }}
                onClick={() => {
                  dispatch(desfazerConexao());
                  dispatch(desfazerSecretaria());
                  limpaLoginAnonimo(dadosLogin);
                  history.push('/totem');
                }}
              />
            )}
            <AppBody totem desfoque={dadosModal.desfoque}>
              <BreadCumbs>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    Você está em:
                    {' '}
                    {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
                    {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
                    {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
                    {' '}
                    &rsaquo;
                    {' '}
                    {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha manifestação</span>)}
                    {(sic) && (<span style={{ fontWeight: 'bold' }}>Acompanhar meu pedido</span>)}
                    {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha solicitação</span>)}
                  </div>
                  <div>
                    <span style={{ textAlign: 'right' }}>Logado como: </span>
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
                  </div>
                </div>
              </BreadCumbs>
              <Container style={{ marginTop: 180, paddingInline: 95 }} totem>
                <span style={{ color: 'red' }}>Não há manifestações cadastradas.</span>

                <Divisor size="pequeno" />

              </Container>
            </AppBody>
          </AppFragment>

        );
      }

      const filtro = listaOcorrencias.filter(({ Id }) => Id.includes(values.BuscaOcorrencia));

      const possuiAbertos = filtro.find((ocorrencia) => ocorrencia.Status === 'Aberto');
      const possuiAgendados = filtro.find((ocorrencia) => ocorrencia.Status === 'Agendado');
      const possuiEmAndamento = filtro.find((ocorrencia) => ocorrencia.Status === 'Em andamento');
      const possuiPendentes = filtro.find((ocorrencia) => ocorrencia.Status === 'Pendente');
      const possuiConcluidos = filtro.find((ocorrencia) => ocorrencia.Status === 'Concluído');
      const possuiCancelados = filtro.find((ocorrencia) => ocorrencia.Status === 'Cancelado');

      const onRefresh = () => {
        setRefresh(true);
      };

      return (
        <AppFragment
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              dispatch(resetarModais());
            }
          }}
          tabIndex="0"
        >
          {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
          {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
          {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
          {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
          {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
          <Botao
            onClick={() => document.getElementById('formAcompanhamento').scrollBy({
              top: -850,
              left: 0,
              behavior: 'smooth',
            })}
            totemUp
          />
          <Botao
            onClick={() => document.getElementById('formAcompanhamento').scrollBy({
              top: 850,
              left: 0,
              behavior: 'smooth',
            })}
            totemDown
          />
          <Botao
            voltar
            label="Voltar"
            style={{
              marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
            }}
            onClick={() => handleVoltar()}
          />
          {(dadosLogin && dadosLogin.data) && (
            <Botao
              sair
              label="Sair"
              style={{ marginRight: espacamento.pequeno }}
              onClick={() => {
                dispatch(desfazerConexao());
                dispatch(desfazerSecretaria());
                limpaLoginAnonimo(dadosLogin);
                history.push('/totem');
              }}
            />
          )}
          <AppBody id="formAcompanhamento" totem desfoque={dadosModal.desfoque}>
            <BreadCumbs>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  Você está em:
                  {' '}
                  {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
                  {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
                  {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
                  {' '}
                  &rsaquo;
                  {' '}
                  {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha manifestação</span>)}
                  {(sic) && (<span style={{ fontWeight: 'bold' }}>Acompanhar meu pedido</span>)}
                  {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha solicitação</span>)}
                </div>
                <div>
                  <span style={{ textAlign: 'right' }}>Logado como: </span>
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
                </div>
              </div>
            </BreadCumbs>
            <Container style={{ marginTop: 180, paddingInline: 95 }} totem>
              <Interno>
                <Linha>
                  <span style={{ marginRight: espacamento.pequeno, fontSize: 20 }}>
                    Protocolo:
                  </span>
                  <CampoFormTotem
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    value={values.BuscaOcorrencia}
                    onChange={({ target }) => setValues({
                      ...values,
                      BuscaOcorrencia: target.value,
                    })}
                  />
                </Linha>

                <Divisor border size="pequeno" />

                <Divisor />

                {possuiAbertos && (
                <>
                  <HeaderLista
                    type="ocorrencia-aberta"
                  />

                  <Divisor />
                </>
                )}

                {filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Aberto') {
                    return (
                      <ListaOcorrencias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                      />
                    );
                  }
                  return null;
                })}

                {possuiAgendados && (
                <>
                  <HeaderLista
                    type="ocorrencia-agendada"
                  />

                  <Divisor />
                </>
                )}
                {filtro.length > 0 && filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Agendado') {
                    return (
                      <ListaOcorrencias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                      />
                    );
                  }
                  return null;
                })}

                {possuiEmAndamento && (
                <>
                  <HeaderLista
                    type="ocorrencia-emandamento"
                  />

                  <Divisor />
                </>
                )}

                {filtro.length > 0 && filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Em andamento') {
                    return (
                      <ListaOcorrencias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                      />
                    );
                  }
                  return null;
                })}

                {possuiPendentes && (
                <>
                  <HeaderLista
                    type="ocorrencia-pendente"
                  />

                  <Divisor />
                </>
                )}
                {filtro.length > 0 && filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Pendente') {
                    return (
                      <ListaOcorrencias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                      />
                    );
                  }
                  return null;
                })}

                {possuiConcluidos && (
                <>
                  <HeaderLista
                    type="ocorrencia-concluida"
                  />

                  <Divisor />
                </>
                )}

                {filtro.length > 0 && filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Concluído') {
                    return (
                      <ListaOcorrencias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                        dataHoraCanceladoConcluido={ocorrencia.DataHoraCanceladoConcluido}
                      />
                    );
                  }
                  return null;
                })}

                {possuiCancelados && (
                <>
                  <HeaderLista
                    type="ocorrencia-cancelada"
                  />

                  <Divisor />
                </>
                )}

                {filtro.length > 0 && filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Cancelado') {
                    return (
                      <ListaOcorrencias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                        dataHoraCanceladoConcluido={ocorrencia.DataHoraCanceladoConcluido}
                      />
                    );
                  }
                  return null;
                })}

              </Interno>
            </Container>
          </AppBody>
        </AppFragment>

      );
    }

    if (sic) {
      if (listaSic.Message) {
        return (
          <AppFragment
            onKeyDown={(e) => {
              if (e.key === 'Escape') {
                dispatch(resetarModais());
              }
            }}
            tabIndex="0"
          >
            {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
            {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
            {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
            {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
            {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
            {dadosModal.modalImpressaoSic === 'aberto' && (<ModalImpressaoSic />)}
            {dadosModal.modalAjuda === 'aberto' && (<ModalInformacaoAcompanhamento sic />)}
            <Botao
              voltar
              label="Voltar"
              style={{
                marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
              }}
              onClick={() => handleVoltar()}
            />
            {(dadosLogin && dadosLogin.data) && (
              <Botao
                sair
                label="Sair"
                style={{ marginRight: espacamento.pequeno }}
                onClick={() => {
                  dispatch(desfazerConexao());
                  dispatch(desfazerSecretaria());
                  limpaLoginAnonimo(dadosLogin);
                  history.push('/totem');
                }}
              />
            )}
            <AppBody totem desfoque={dadosModal.desfoque}>
              <BreadCumbs>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    Você está em:
                    {' '}
                    {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
                    {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
                    {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
                    {' '}
                    &rsaquo;
                    {' '}
                    {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha manifestação</span>)}
                    {(sic) && (<span style={{ fontWeight: 'bold' }}>Acompanhar meu pedido</span>)}
                    {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha solicitação</span>)}
                  </div>
                  <div>
                    <span style={{ textAlign: 'right' }}>Logado como: </span>
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
                  </div>
                </div>
              </BreadCumbs>
              <Container style={{ marginTop: 180, paddingInline: 95 }} totem>
                <span style={{ color: 'red' }}>Não há pedidos de informação cadastrados.</span>

                <Divisor size="pequeno" />

              </Container>
            </AppBody>
          </AppFragment>

        );
      }

      const filtro = listaSic.filter(({ Id }) => Id.includes(values.BuscaSic));

      const possuiPendentes = filtro.find((sc) => !sc.Resposta && !sc.RespostaRecurso);

      const possuiRespondidos = filtro.find((sc) => sc.Resposta && sc.RespostaRecurso);

      return (
        <AppFragment
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              dispatch(resetarModais());
            }
          }}
          tabIndex="0"
        >
          {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
          {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
          {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
          {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
          {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
          {dadosModal.modalImpressaoSic === 'aberto' && (<ModalImpressaoSic />)}
          {dadosModal.modalAjuda === 'aberto' && (<ModalInformacaoAcompanhamento sic />)}
          {listaSic > 10 && (
          <>
            <Botao
              onClick={() => document.getElementById('formAcompanhamentoSic').scrollBy({
                top: -850,
                left: 0,
                behavior: 'smooth',
              })}
              totemUp
            />
            <Botao
              onClick={() => document.getElementById('formAcompanhamentoSic').scrollBy({
                top: 850,
                left: 0,
                behavior: 'smooth',
              })}
              totemDown
            />

          </>
          )}
          <Botao
            voltar
            label="Voltar"
            style={{
              marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
            }}
            onClick={() => handleVoltar()}
          />
          {(dadosLogin && dadosLogin.data) && (
            <Botao
              sair
              label="Sair"
              style={{ marginRight: espacamento.pequeno }}
              onClick={() => {
                dispatch(desfazerConexao());
                dispatch(desfazerSecretaria());
                limpaLoginAnonimo(dadosLogin);
                history.push('/totem');
              }}
            />
          )}
          <AppBody id="formAcompanhamento" totem desfoque={dadosModal.desfoque}>
            <BreadCumbs>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  Você está em:
                  {' '}
                  {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
                  {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
                  {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
                  {' '}
                  &rsaquo;
                  {' '}
                  {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha manifestação</span>)}
                  {(sic) && (<span style={{ fontWeight: 'bold' }}>Acompanhar meu pedido</span>)}
                  {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha solicitação</span>)}
                </div>
                <div>
                  <span style={{ textAlign: 'right' }}>Logado como: </span>
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
                </div>
              </div>
            </BreadCumbs>
            <Container style={{ marginTop: 180, paddingInline: 95 }} totem>
              <Interno>
                <Linha>
                  <span style={{ marginRight: espacamento.pequeno, fontSize: 20 }}>
                    Protocolo:
                  </span>
                  <CampoForm
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    value={values.BuscaSic}
                    onChange={({ target }) => setValues({
                      ...values,
                      BuscaSic: target.value,
                    })}
                  />
                </Linha>

                <Divisor border size="pequeno" />

                <Divisor />
                {possuiPendentes && (
                  <>
                    <HeaderLista
                      type="sic-pendente"
                    />

                    <Divisor />
                  </>
                )}

                {filtro.map((sc) => {
                  if (!sc.Resposta && !sc.RespostaRecurso && sc.Retificado === 'N') {
                    return (
                      <ListaSic
                        key={sc.Id}
                        id={sc.Id}
                        assunto={sc.Assunto}
                        dataHora={sc.DataHora}
                        secretaria={sc.Secretaria}
                        pergunta={sc.Pergunta}
                        resposta={sc.Resposta}
                        arquivos={sc.Arquivos}
                        dataHoraResposta={sc.DataHoraResposta}
                        recurso={sc.Recurso}
                        respostaRecurso={sc.RespostaRecurso}
                        dataHoraRespostaRecurso={sc.DataHoraRespostaRecurso}
                        dataHoraAberturaRecurso={sc.DataHoraAberturaRecurso}
                        carregandoCallback={carregandoCallback}
                        retificacao={sc.Retificacao}
                        dataHoraRetificacao={sc.DataHoraRetificacao}
                        visivelRetificacao={sc.VisivelRetificacao}
                        recursoRetificacao={sc.RecursoRetificacao}
                        dataHoraAberturaRecursoRetificacao={sc.DataHoraAberturaRecursoRetificacao}
                        dataHoraRespostaRecursoRetificacao={sc.DataHoraRespostaRecursoRetificacao}
                        respostaRecursoRetificacao={sc.RespostaRecursoRetificacao}
                      />
                    );
                  }
                  return null;
                })}

                {possuiRespondidos && (
                  <>
                    <HeaderLista
                      type="sic-respondido"
                    />

                    <Divisor />
                  </>
                )}

                {filtro.map((sc) => {
                  if (sc.Resposta || sc.Retificado === 'S') {
                    return (
                      <ListaSic
                        key={sc.Id}
                        id={sc.Id}
                        assunto={sc.Assunto}
                        dataHora={sc.DataHora}
                        secretaria={sc.Secretaria}
                        pergunta={sc.Pergunta}
                        resposta={sc.Resposta}
                        arquivos={sc.Arquivos}
                        dataHoraResposta={sc.DataHoraResposta}
                        recurso={sc.Recurso}
                        respostaRecurso={sc.RespostaRecurso}
                        dataHoraRespostaRecurso={sc.DataHoraRespostaRecurso}
                        dataHoraAberturaRecurso={sc.DataHoraAberturaRecurso}
                        carregandoCallback={carregandoCallback}
                        retificacao={sc.Retificacao}
                        dataHoraRetificacao={sc.DataHoraRetificacao}
                        visivelRetificacao={sc.VisivelRetificacao}
                        recursoRetificacao={sc.RecursoRetificacao}
                        dataHoraAberturaRecursoRetificacao={sc.DataHoraAberturaRecursoRetificacao}
                        dataHoraRespostaRecursoRetificacao={sc.DataHoraRespostaRecursoRetificacao}
                        respostaRecursoRetificacao={sc.RespostaRecursoRetificacao}
                      />
                    );
                  }
                  if (sc.Resposta || sc.RespostaRecurso) {
                    return (
                      <ListaSic
                        key={sc.Id}
                        id={sc.Id}
                        assunto={sc.Assunto}
                        dataHora={sc.DataHora}
                        secretaria={sc.Secretaria}
                        pergunta={sc.Pergunta}
                        resposta={sc.Resposta}
                        arquivos={sc.Arquivos}
                        dataHoraResposta={sc.DataHoraResposta}
                        recurso={sc.Recurso}
                        respostaRecurso={sc.RespostaRecurso}
                        dataHoraRespostaRecurso={sc.DataHoraRespostaRecurso}
                        dataHoraAberturaRecurso={sc.DataHoraAberturaRecurso}
                        carregandoCallback={carregandoCallback}
                        visivelRetificacao={sc.VisivelRetificacao}
                        recursoRetificacao={sc.RecursoRetificacao}
                        dataHoraAberturaRecursoRetificacao={sc.DataHoraAberturaRecursoRetificacao}
                        dataHoraRespostaRecursoRetificacao={sc.DataHoraRespostaRecursoRetificacao}
                        respostaRecursoRetificacao={sc.RespostaRecursoRetificacao}
                      />
                    );
                  }
                  return null;
                })}
              </Interno>
            </Container>
          </AppBody>
        </AppFragment>
      );
    }

    if (zeladoria) {
      if (listaZeladorias.Message) {
        return (
          <AppFragment
            onKeyDown={(e) => {
              if (e.key === 'Escape') {
                dispatch(resetarModais());
              }
            }}
            tabIndex="0"
          >
            {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
            {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
            {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
            {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
            {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
            {dadosModal.modalImpressaoSic === 'aberto' && (<ModalImpressaoSic />)}
            {dadosModal.modalImpressaoZeladoria === 'aberto' && (<ModalImpressaoZeladoria />)}
            {dadosModal.modalAjuda === 'aberto' && (<ModalInformacaoAcompanhamento zeladoria />)}
            <Botao
              voltar
              label="Voltar"
              style={{
                marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
              }}
              onClick={() => handleVoltar()}
            />
            {(dadosLogin && dadosLogin.data) && (
              <Botao
                sair
                label="Sair"
                style={{ marginRight: espacamento.pequeno }}
                onClick={() => {
                  dispatch(desfazerConexao());
                  dispatch(desfazerSecretaria());
                  limpaLoginAnonimo(dadosLogin);
                  history.push('/totem');
                }}
              />
            )}
            <AppBody totem desfoque={dadosModal.desfoque}>
              <BreadCumbs>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    Você está em:
                    {' '}
                    {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
                    {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
                    {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
                    {' '}
                    &rsaquo;
                    {' '}
                    {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha manifestação</span>)}
                    {(sic) && (<span style={{ fontWeight: 'bold' }}>Acompanhar meu pedido</span>)}
                    {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha solicitação</span>)}
                  </div>
                  <div>
                    <span style={{ textAlign: 'right' }}>Logado como: </span>
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
                  </div>
                </div>
              </BreadCumbs>
              <Container style={{ marginTop: 180, paddingInline: 95 }} totem>
                <span style={{ color: 'red' }}>Não há manifestações cadastradas.</span>

                <Divisor size="pequeno" />

              </Container>
            </AppBody>
          </AppFragment>

        );
      }

      const filtro = listaZeladorias.filter(({ Id }) => Id.includes(values.BuscaZeladoria));

      const possuiAbertos = filtro.find((ocorrencia) => ocorrencia.Status === 'Aberto');
      const possuiAgendados = filtro.find((ocorrencia) => ocorrencia.Status === 'Agendado');
      const possuiEmAndamento = filtro.find((ocorrencia) => ocorrencia.Status === 'Em andamento');
      const possuiPendentes = filtro.find((ocorrencia) => ocorrencia.Status === 'Pendente');
      const possuiConcluidos = filtro.find((ocorrencia) => ocorrencia.Status === 'Concluído');
      const possuiCancelados = filtro.find((ocorrencia) => ocorrencia.Status === 'Cancelado');

      const onRefresh = () => {
        setRefresh(true);
      };

      return (
        <AppFragment
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              dispatch(resetarModais());
            }
          }}
          tabIndex="0"
        >
          {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
          {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
          {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
          {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
          {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
          {dadosModal.modalImpressaoSic === 'aberto' && (<ModalImpressaoSic />)}
          {dadosModal.modalImpressaoZeladoria === 'aberto' && (<ModalImpressaoZeladoria />)}
          {dadosModal.modalAjuda === 'aberto' && (<ModalInformacaoAcompanhamento zeladoria />)}
          <Botao
            onClick={() => document.getElementById('formAcompanhamento').scrollBy({
              top: -850,
              left: 0,
              behavior: 'smooth',
            })}
            totemUp
          />
          <Botao
            onClick={() => document.getElementById('formAcompanhamento').scrollBy({
              top: 850,
              left: 0,
              behavior: 'smooth',
            })}
            totemDown
          />
          <Botao
            voltar
            label="Voltar"
            style={{
              marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
            }}
            onClick={() => handleVoltar()}
          />
          {(dadosLogin && dadosLogin.data) && (
            <Botao
              sair
              label="Sair"
              style={{ marginRight: espacamento.pequeno }}
              onClick={() => {
                dispatch(desfazerConexao());
                dispatch(desfazerSecretaria());
                limpaLoginAnonimo(dadosLogin);
                history.push('/totem');
              }}
            />
          )}
          <AppBody id="formAcompanhamento" totem desfoque={dadosModal.desfoque}>
            <BreadCumbs>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  Você está em:
                  {' '}
                  {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
                  {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
                  {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
                  {' '}
                  &rsaquo;
                  {' '}
                  {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha manifestação</span>)}
                  {(sic) && (<span style={{ fontWeight: 'bold' }}>Acompanhar meu pedido</span>)}
                  {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha solicitação</span>)}
                </div>
                <div>
                  <span style={{ textAlign: 'right' }}>Logado como: </span>
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
                </div>
              </div>
            </BreadCumbs>
            <Container style={{ marginTop: 180, paddingInline: 95 }} totem>
              <Interno>
                <Linha>
                  <span style={{ marginRight: espacamento.pequeno, fontSize: 20 }}>
                    Protocolo:
                  </span>
                  <CampoFormTotem
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    value={values.BuscaZeladoria}
                    onChange={({ target }) => setValues({
                      ...values,
                      BuscaZeladoria: target.value,
                    })}
                  />
                </Linha>

                <Divisor border size="pequeno" />

                <Divisor />

                {possuiAbertos && (
                <>
                  <HeaderLista
                    type="ocorrencia-aberta"
                  />

                  <Divisor />
                </>
                )}

                {filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Aberto') {
                    return (
                      <ListaZeladorias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                      />
                    );
                  }
                  return null;
                })}

                {possuiAgendados && (
                <>
                  <HeaderLista
                    type="ocorrencia-agendada"
                  />

                  <Divisor />
                </>
                )}
                {filtro.length > 0 && filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Agendado') {
                    return (
                      <ListaZeladorias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                      />
                    );
                  }
                  return null;
                })}

                {possuiEmAndamento && (
                <>
                  <HeaderLista
                    type="ocorrencia-emandamento"
                  />

                  <Divisor />
                </>
                )}

                {filtro.length > 0 && filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Em andamento') {
                    return (
                      <ListaZeladorias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                      />
                    );
                  }
                  return null;
                })}

                {possuiPendentes && (
                <>
                  <HeaderLista
                    type="ocorrencia-pendente"
                  />

                  <Divisor />
                </>
                )}
                {filtro.length > 0 && filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Pendente') {
                    return (
                      <ListaZeladorias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                      />
                    );
                  }
                  return null;
                })}

                {possuiConcluidos && (
                <>
                  <HeaderLista
                    type="ocorrencia-concluida"
                  />

                  <Divisor />
                </>
                )}

                {filtro.length > 0 && filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Concluído') {
                    return (
                      <ListaZeladorias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                        dataHoraCanceladoConcluido={ocorrencia.DataHoraCanceladoConcluido}
                      />
                    );
                  }
                  return null;
                })}

                {possuiCancelados && (
                <>
                  <HeaderLista
                    type="ocorrencia-cancelada"
                  />

                  <Divisor />
                </>
                )}

                {filtro.length > 0 && filtro.map((ocorrencia) => {
                  if (ocorrencia.Status === 'Cancelado') {
                    return (
                      <ListaZeladorias
                        key={ocorrencia.Id}
                        arquivos={ocorrencia.Arquivos}
                        id={ocorrencia.Id}
                        secretaria={ocorrencia.Secretaria}
                        dataHora={ocorrencia.DataHora}
                        descricao={ocorrencia.Descricao}
                        assunto={ocorrencia.Assunto}
                        bairro={ocorrencia.Bairro}
                        andamentos={ocorrencia.Historicos}
                        status={ocorrencia.Status}
                        likeUnlike={ocorrencia.LikeUnlike}
                        onRefresh={onRefresh}
                        endereco={ocorrencia.Endereco}
                        numero={ocorrencia.Numero}
                        dataHoraCanceladoConcluido={ocorrencia.DataHoraCanceladoConcluido}
                      />
                    );
                  }
                  return null;
                })}

              </Interno>
            </Container>
          </AppBody>
        </AppFragment>

      );
    }
    return null;
  }

  // anonimo
  if (ouvidoria) {
    const pesquisaOuvidoriaAnonimo = async (value) => {
      const response = await fetch(`https://eouve.com.br/API/${dadosCidade && dadosCidade.data && dadosCidade.data.idCidade}/solicitante/ouvidoriasanonima?idouvidoria=${value}`);
      const data = await response.json();
      if (data.Message) {
        setResultadoPesquisaOuvidoriaAnonimo(data);
        return;
      }
      setResultadoPesquisaOuvidoriaAnonimo(data[0]);
    };

    const onRefresh = () => {
      setRefresh(true);
    };

    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
        <Botao
          voltar
          label="Voltar"
          style={{
            marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
          }}
          onClick={() => handleVoltar()}
        />
        {(dadosLogin && dadosLogin.data) && (
          <Botao
            sair
            label="Sair"
            style={{ marginRight: espacamento.pequeno }}
            onClick={() => {
              dispatch(desfazerConexao());
              dispatch(desfazerSecretaria());
              limpaLoginAnonimo(dadosLogin);
              history.push('/totem');
            }}
          />
        )}
        <AppBody totem desfoque={dadosModal.desfoque}>
          <BreadCumbs>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                Você está em:
                {' '}
                {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
                {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
                {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
                {' '}
                &rsaquo;
                {' '}
                {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha manifestação</span>)}
                {(sic) && (<span style={{ fontWeight: 'bold' }}>Acompanhar meu pedido</span>)}
                {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha solicitação</span>)}
              </div>
              <div>
                <span style={{ textAlign: 'right' }}>Logado como: </span>
                <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
              </div>
            </div>
          </BreadCumbs>
          <Container style={{ marginTop: 180, paddingInline: 95 }} totem>
            <Interno>
              <Linha style={{ flexWrap: 'wrap' }}>
                <span style={{ marginRight: espacamento.pequeno, fontSize: 20 }}>
                  Protocolo:
                </span>
                <CampoFormTotem
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  style={{ minWidth: '200' }}
                  value={values.BuscaOcorrencia}
                  onChange={({ target }) => setValues({
                    ...values,
                    BuscaOcorrencia: target.value,
                  })}
                />
                <Botao cep onClick={() => pesquisaOuvidoriaAnonimo(values.BuscaOcorrencia)} />
              </Linha>
            </Interno>
            <Divisor size="pequeno" />

            <Divisor />
            {(resultadoPesquisaOuvidoriaAnonimo && !resultadoPesquisaOuvidoriaAnonimo.Message && resultadoPesquisaOuvidoriaAnonimo.Status === 'Aberto')
            && (
            <>
              <HeaderLista type="ocorrencia-aberta2" />
              <Divisor />
            </>
            )}
            {(resultadoPesquisaOuvidoriaAnonimo && !resultadoPesquisaOuvidoriaAnonimo.Message && resultadoPesquisaOuvidoriaAnonimo.Status === 'Agendado')
            && (
            <>
              <HeaderLista type="ocorrencia-agendada2" />
              <Divisor />
            </>
            )}
            {(resultadoPesquisaOuvidoriaAnonimo && !resultadoPesquisaOuvidoriaAnonimo.Message && resultadoPesquisaOuvidoriaAnonimo.Status === 'Em andamento')
            && (
            <>
              <HeaderLista type="ocorrencia-emandamento2" />
              <Divisor />
            </>
            )}
            {(resultadoPesquisaOuvidoriaAnonimo && !resultadoPesquisaOuvidoriaAnonimo.Message && resultadoPesquisaOuvidoriaAnonimo.Status === 'Pendente')
            && (
            <>
              <HeaderLista type="ocorrencia-pendente2" />
              <Divisor />
            </>
            )}
            {(resultadoPesquisaOuvidoriaAnonimo && !resultadoPesquisaOuvidoriaAnonimo.Message && resultadoPesquisaOuvidoriaAnonimo.Status === 'Concluído')
            && (
            <>
              <HeaderLista type="ocorrencia-concluida2" />
              <Divisor />
            </>
            )}
            {(resultadoPesquisaOuvidoriaAnonimo && !resultadoPesquisaOuvidoriaAnonimo.Message && resultadoPesquisaOuvidoriaAnonimo.Status === 'Cancelado')
            && (
            <>
              <HeaderLista type="ocorrencia-cancelada2" />
              <Divisor />
            </>
            )}
            { (resultadoPesquisaOuvidoriaAnonimo && !resultadoPesquisaOuvidoriaAnonimo.Message) ? (
              <ListaOcorrencias
                key={resultadoPesquisaOuvidoriaAnonimo.Id}
                arquivos={resultadoPesquisaOuvidoriaAnonimo.Arquivos}
                id={resultadoPesquisaOuvidoriaAnonimo.Id}
                secretaria={resultadoPesquisaOuvidoriaAnonimo.Secretaria}
                dataHora={resultadoPesquisaOuvidoriaAnonimo.DataHora}
                descricao={resultadoPesquisaOuvidoriaAnonimo.Descricao}
                assunto={resultadoPesquisaOuvidoriaAnonimo.Assunto}
                bairro={resultadoPesquisaOuvidoriaAnonimo.Bairro}
                andamentos={resultadoPesquisaOuvidoriaAnonimo.Historicos}
                status={resultadoPesquisaOuvidoriaAnonimo.Status}
                likeUnlike={resultadoPesquisaOuvidoriaAnonimo.LikeUnlike}
                onRefresh={onRefresh}
                endereco={resultadoPesquisaOuvidoriaAnonimo.Endereco}
                numero={resultadoPesquisaOuvidoriaAnonimo.Numero}
              />
            ) : (resultadoPesquisaOuvidoriaAnonimo && resultadoPesquisaOuvidoriaAnonimo.Message && (
            <Linha>
              <span style={{
                marginRight: espacamento.pequeno, fontSize: 16, color: '#ED5F55', padding: 10, width: '100%',
              }}
              >
                Nenhum resultado foi encontrado.
              </span>
            </Linha>
            )) }
            <Divisor size="medio" />
          </Container>
        </AppBody>
      </AppFragment>
    );
  }

  if (sic) {
    const pesquisaSicAnonimo = async (value) => {
      const response = await fetch(`https://eouve.com.br/api/${dadosCidade.data.idCidade}/solicitante/sicsanonima?idsic=${value}`);
      const data = await response.json();
      if (data.Message) {
        setResultadoPesquisaSicAnonimo(data);
        return;
      }
      setResultadoPesquisaSicAnonimo(data[0]);
    };

    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
        {dadosModal.modalImpressaoSic === 'aberto' && (<ModalImpressaoSic />)}
        {dadosModal.modalAjuda === 'aberto' && (<ModalInformacaoAcompanhamento sic />)}
        <Botao
          voltar
          label="Voltar"
          style={{
            marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
          }}
          onClick={() => handleVoltar()}
        />
        {(dadosLogin && dadosLogin.data) && (
          <Botao
            sair
            label="Sair"
            style={{ marginRight: espacamento.pequeno }}
            onClick={() => {
              dispatch(desfazerConexao());
              dispatch(desfazerSecretaria());
              limpaLoginAnonimo(dadosLogin);
              history.push('/totem');
            }}
          />
        )}
        <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque}>
          <BreadCumbs>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                Você está em:
                {' '}
                {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
                {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
                {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
                {' '}
                &rsaquo;
                {' '}
                {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha manifestação</span>)}
                {(sic) && (<span style={{ fontWeight: 'bold' }}>Acompanhar meu pedido</span>)}
                {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha solicitação</span>)}
              </div>
              <div>
                <span style={{ textAlign: 'right' }}>Logado como: </span>
                <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
              </div>
            </div>
          </BreadCumbs>
          <Container style={{ marginTop: 180, paddingInline: 95 }} totem>
            <Interno>
              <Linha>
                <span style={{ marginRight: espacamento.pequeno }}>
                  Protocolo:
                </span>
                <CampoForm
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  value={values.BuscaSic}
                  onChange={({ target }) => setValues({
                    ...values,
                    BuscaSic: target.value,
                  })}
                />
                <Botao cep onClick={() => pesquisaSicAnonimo(values.BuscaSic)} />
              </Linha>
            </Interno>

            <Divisor border size="pequeno" />

            <Divisor />

            {(resultadoPesquisaSicAnonimo && !resultadoPesquisaSicAnonimo.Message && !resultadoPesquisaSicAnonimo.Resposta && resultadoPesquisaSicAnonimo.Retificado === 'N')
            && (
            <>
              <HeaderLista type="sic-pendente2" />
              <Divisor />
            </>
            )}
            {((resultadoPesquisaSicAnonimo && !resultadoPesquisaSicAnonimo.Message && resultadoPesquisaSicAnonimo.Resposta)
            || (resultadoPesquisaSicAnonimo && resultadoPesquisaSicAnonimo.Retificado === 'S')) && (
            <>
              <HeaderLista type="sic-respondido2" />
              <Divisor />
            </>
            )}
            { (resultadoPesquisaSicAnonimo && !resultadoPesquisaSicAnonimo.Message) ? (
              <ListaSic
                key={resultadoPesquisaSicAnonimo.Id}
                id={resultadoPesquisaSicAnonimo.Id}
                assunto={resultadoPesquisaSicAnonimo.Assunto}
                dataHora={resultadoPesquisaSicAnonimo.DataHora}
                secretaria={resultadoPesquisaSicAnonimo.Secretaria}
                pergunta={resultadoPesquisaSicAnonimo.Pergunta}
                resposta={resultadoPesquisaSicAnonimo.Resposta}
                arquivos={resultadoPesquisaSicAnonimo.Arquivos}
                dataHoraResposta={resultadoPesquisaSicAnonimo.DataHoraResposta}
                recurso={resultadoPesquisaSicAnonimo.Recurso}
                respostaRecurso={resultadoPesquisaSicAnonimo.RespostaRecurso}
                dataHoraRespostaRecurso={resultadoPesquisaSicAnonimo.DataHoraRespostaRecurso}
                dataHoraAberturaRecurso={resultadoPesquisaSicAnonimo.DataHoraAberturaRecurso}
                carregandoCallback={carregandoCallback}
                retificacao={resultadoPesquisaSicAnonimo.Retificacao}
                dataHoraRetificacao={resultadoPesquisaSicAnonimo.DataHoraRetificacao}
                visivelRetificacao={resultadoPesquisaSicAnonimo.VisivelRetificacao}
                recursoRetificacao={resultadoPesquisaSicAnonimo.RecursoRetificacao}
                dataHoraAberturaRecursoRetificacao={resultadoPesquisaSicAnonimo.DataHoraAberturaRecursoRetificacao}
                dataHoraRespostaRecursoRetificacao={resultadoPesquisaSicAnonimo.DataHoraRespostaRecursoRetificacao}
                respostaRecursoRetificacao={resultadoPesquisaSicAnonimo.RespostaRecursoRetificacao}
              />
            ) : (resultadoPesquisaSicAnonimo && resultadoPesquisaSicAnonimo.Message && (
              <Linha>
                <span style={{
                  marginRight: espacamento.pequeno, fontSize: 16, color: '#ED5F55', padding: 10, width: '100%',
                }}
                >
                  Nenhum resultado foi encontrado.
                </span>
              </Linha>
            )) }
          </Container>
        </AppBody>
      </AppFragment>
    );
  }

  if (zeladoria) {
    const pesquisaZeladoriaAnonimo = async (value) => {
      const response = await fetch(`https://eouve.com.br/API/${dadosCidade && dadosCidade.data && dadosCidade.data.idCidade}/solicitante/zeladoriasanonima?idouvidoria=${value}`);
      const data = await response.json();
      if (data.Message) {
        setResultadoPesquisaZeladoriaAnonimo(data);
        return;
      }
      setResultadoPesquisaZeladoriaAnonimo(data[0]);
    };

    const onRefresh = () => {
      setRefresh(true);
    };

    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalImpressao === 'aberto' && (<ModalImpressao />)}
        {dadosModal.modalImpressaoSic === 'aberto' && (<ModalImpressaoSic />)}
        {dadosModal.modalImpressaoZeladoria === 'aberto' && (<ModalImpressaoZeladoria />)}
        {dadosModal.modalAjuda === 'aberto' && (<ModalInformacaoAcompanhamento zeladoria />)}
        <Botao
          voltar
          label="Voltar"
          style={{
            marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
          }}
          onClick={() => handleVoltar()}
        />
        {(dadosLogin && dadosLogin.data) && (
          <Botao
            sair
            label="Sair"
            style={{ marginRight: espacamento.pequeno }}
            onClick={() => {
              dispatch(desfazerConexao());
              dispatch(desfazerSecretaria());
              limpaLoginAnonimo(dadosLogin);
              history.push('/totem');
            }}
          />
        )}
        <AppBody totem desfoque={dadosModal.desfoque}>
          <BreadCumbs>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                Você está em:
                {' '}
                {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
                {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
                {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
                {' '}
                &rsaquo;
                {' '}
                {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha manifestação</span>)}
                {(sic) && (<span style={{ fontWeight: 'bold' }}>Acompanhar meu pedido</span>)}
                {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Acompanhar minha solicitação</span>)}
              </div>
              <div>
                <span style={{ textAlign: 'right' }}>Logado como: </span>
                <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
              </div>
            </div>
          </BreadCumbs>
          <Container style={{ marginTop: 180, paddingInline: 95 }} totem>
            <Interno>
              <Linha style={{ flexWrap: 'wrap' }}>
                <span style={{ marginRight: espacamento.pequeno, fontSize: 20 }}>
                  Protocolo:
                </span>
                <CampoFormTotem
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  style={{ minWidth: '200' }}
                  value={values.BuscaZeladoria}
                  onChange={({ target }) => setValues({
                    ...values,
                    BuscaZeladoria: target.value,
                  })}
                />
                <Botao cep onClick={() => pesquisaZeladoriaAnonimo(values.BuscaZeladoria)} />
              </Linha>
            </Interno>
            <Divisor size="pequeno" />

            <Divisor />
            {(resultadoPesquisaZeladoriaAnonimo && !resultadoPesquisaZeladoriaAnonimo.Message && resultadoPesquisaZeladoriaAnonimo.Status === 'Aberto')
            && (
            <>
              <HeaderLista type="ocorrencia-aberta2" />
              <Divisor />
            </>
            )}
            {(resultadoPesquisaZeladoriaAnonimo && !resultadoPesquisaZeladoriaAnonimo.Message && resultadoPesquisaZeladoriaAnonimo.Status === 'Agendado')
            && (
            <>
              <HeaderLista type="ocorrencia-agendada2" />
              <Divisor />
            </>
            )}
            {(resultadoPesquisaZeladoriaAnonimo && !resultadoPesquisaZeladoriaAnonimo.Message && resultadoPesquisaZeladoriaAnonimo.Status === 'Em andamento')
            && (
            <>
              <HeaderLista type="ocorrencia-emandamento2" />
              <Divisor />
            </>
            )}
            {(resultadoPesquisaZeladoriaAnonimo && !resultadoPesquisaZeladoriaAnonimo.Message && resultadoPesquisaZeladoriaAnonimo.Status === 'Pendente')
            && (
            <>
              <HeaderLista type="ocorrencia-pendente2" />
              <Divisor />
            </>
            )}
            {(resultadoPesquisaZeladoriaAnonimo && !resultadoPesquisaZeladoriaAnonimo.Message && resultadoPesquisaZeladoriaAnonimo.Status === 'Concluído')
            && (
            <>
              <HeaderLista type="ocorrencia-concluida2" />
              <Divisor />
            </>
            )}
            {(resultadoPesquisaZeladoriaAnonimo && !resultadoPesquisaZeladoriaAnonimo.Message && resultadoPesquisaZeladoriaAnonimo.Status === 'Cancelado')
            && (
            <>
              <HeaderLista type="ocorrencia-cancelada2" />
              <Divisor />
            </>
            )}
            { (resultadoPesquisaZeladoriaAnonimo && !resultadoPesquisaZeladoriaAnonimo.Message) ? (
              <ListaZeladorias
                key={resultadoPesquisaOuvidoriaAnonimo.Id}
                arquivos={resultadoPesquisaOuvidoriaAnonimo.Arquivos}
                id={resultadoPesquisaOuvidoriaAnonimo.Id}
                secretaria={resultadoPesquisaOuvidoriaAnonimo.Secretaria}
                dataHora={resultadoPesquisaOuvidoriaAnonimo.DataHora}
                descricao={resultadoPesquisaOuvidoriaAnonimo.Descricao}
                assunto={resultadoPesquisaOuvidoriaAnonimo.Assunto}
                bairro={resultadoPesquisaOuvidoriaAnonimo.Bairro}
                andamentos={resultadoPesquisaOuvidoriaAnonimo.Historicos}
                status={resultadoPesquisaOuvidoriaAnonimo.Status}
                likeUnlike={resultadoPesquisaOuvidoriaAnonimo.LikeUnlike}
                onRefresh={onRefresh}
                endereco={resultadoPesquisaOuvidoriaAnonimo.Endereco}
                numero={resultadoPesquisaOuvidoriaAnonimo.Numero}
              />
            ) : (resultadoPesquisaZeladoriaAnonimo && resultadoPesquisaZeladoriaAnonimo.Message && (
            <Linha>
              <span style={{
                marginRight: espacamento.pequeno, fontSize: 16, color: '#ED5F55', padding: 10, width: '100%',
              }}
              >
                Nenhum resultado foi encontrado.
              </span>
            </Linha>
            )) }
            <Divisor size="medio" />
          </Container>
        </AppBody>
      </AppFragment>
    );
  }

  return null;
};

IniciarAcompanhamentoTotem.propTypes = {
  ouvidoria: PropTypes.bool,
  sic: PropTypes.bool,
  zeladoria: PropTypes.bool,
};

IniciarAcompanhamentoTotem.defaultProps = {
  ouvidoria: false,
  sic: false,
  zeladoria: false,
};

export default IniciarAcompanhamentoTotem;
